import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import User from '../../entities/user';
import Matter from '../../entities/matter';
import Deadline from '../../entities/deadline';
import Conflict from '../../entities/conflict';
import Group from '../../entities/group';
import Role from '../../entities/role';
import TemplateTask from '../../entities/templateTask';
import TimeOff from '../../entities/timeOff';
import Task from '../../entities/task';

/*
 * Delete/nullify anywhere this user is used in other entities
 *
 * @param {User} user
 */
export function deleteUser(user: User, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = user.id;
    }
    /* Simple delete usages */
        
    store.getState().matters
        .getMappingFor('userId', user.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.assignedTo = _matter.assignedTo?.filter(id => id !== user.id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().deadlines
        .getMappingFor('userId', user.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.completedBy = null;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    store.getState().conflicts
        .getMappingFor('userIds', user.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.userIds = _conflict.userIds?.filter(id => id !== user.id) || [];
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().groups
        .getMappingFor('userId', user.id)
        .filter(groupTemp => groupTemp.status !== 'D')
        .forEach(groupTemp => {
            const _group = groupTemp.clone();
            _group.status =  'U';
            _group.addedOn = newHRTimestamp();
            _group.importSource = targetImportSource;
            _group.importId = mergeId;

            _group.userIds = _group.userIds?.filter(id => id !== user.id) || [];
            store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
        });

    store.getState().roles
        .getMappingFor('userId', user.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.users = _role.users?.filter(id => id !== user.id) || [];
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    store.getState().templateTasks
        .getMappingFor('userId', user.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.favoritedBy = _templateTask.favoritedBy?.filter(id => id !== user.id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    store.getState().timeOffs
        .getMappingFor('approvedBy', user.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.approvedBy = null;
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    /* Complex delete usages */
        /* - Delete key/value usages */
    
    findAll<Deadline>('deadlines')
        .filter(deadlineTemp => deadlineTemp.assignedToType === 'U' && deadlineTemp.assignedTo === user.id && deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _deadline.status = 'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    findAll<Task>('tasks')
        .filter(taskTemp => taskTemp.assignedToType === 'U' && taskTemp.assignedTo === user.id && taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _task.status = 'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    findAll<TemplateTask>('templateTasks')
        .filter(templateTaskTemp => templateTaskTemp.assignedToType === 'U' && templateTaskTemp.assignedTo === user.id && templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            // Delete the target
            _templateTask.status = 'D';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.addedBy = getCurrentUserId();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    /* - Delete embedded value usages */

    /* Remove the actual user */
    user.status = 'D';
    user.addedOn = newHRTimestamp();
    user.addedBy = getCurrentUserId();
    user.importSource = targetImportSource;
    user.importId = mergeId;
    store.dispatch(Actions.UserActions.removeUserQueue(user));
    
}

/*
 * Replace anywhere this user is used in other entities.
 *
 * @param {User} user
 * @param {User} replaceWith
 * @return {User} - User will have refs stripped away
 */
export function replaceUser(user: User, replaceWith: User, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = user.id;
    }
    /* Simple replace usages */
        
    store.getState().matters
        .getMappingFor('userId', user.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.assignedTo = _matter.assignedTo?.map(id => (id === user.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().deadlines
        .getMappingFor('userId', user.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.completedBy = replaceWith.id;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    store.getState().conflicts
        .getMappingFor('userIds', user.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.userIds = _conflict.userIds?.map(id => (id === user.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().groups
        .getMappingFor('userId', user.id)
        .filter(groupTemp => groupTemp.status !== 'D')
        .forEach(groupTemp => {
            const _group = groupTemp.clone();
            _group.status =  'U';
            _group.addedOn = newHRTimestamp();
            _group.importSource = targetImportSource;
            _group.importId = mergeId;

            _group.userIds = _group.userIds?.map(id => (id === user.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
        });

    store.getState().roles
        .getMappingFor('userId', user.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.users = _role.users?.map(id => (id === user.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    store.getState().templateTasks
        .getMappingFor('userId', user.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.favoritedBy = _templateTask.favoritedBy?.map(id => (id === user.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    store.getState().timeOffs
        .getMappingFor('approvedBy', user.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.approvedBy = replaceWith.id;
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    /* Complex replace usages */
        /* - Modify key/value usages */
    
    findAll<Deadline>('deadlines')
        .filter(deadlineTemp => deadlineTemp.assignedToType === 'U' && deadlineTemp.assignedTo === user.id && deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            // Replace the target with the new ID
			_deadline.assignedTo = replaceWith.id;
            _deadline.status = 'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    findAll<Task>('tasks')
        .filter(taskTemp => taskTemp.assignedToType === 'U' && taskTemp.assignedTo === user.id && taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            // Replace the target with the new ID
			_task.assignedTo = replaceWith.id;
            _task.status = 'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    findAll<TemplateTask>('templateTasks')
        .filter(templateTaskTemp => templateTaskTemp.assignedToType === 'U' && templateTaskTemp.assignedTo === user.id && templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            // Replace the target with the new ID
			_templateTask.assignedTo = replaceWith.id;
            _templateTask.status = 'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.addedBy = getCurrentUserId();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    /* - Modify embedded value usages */
    
    findAll<Matter>('matters')
        // Has to have the hourlyRates property
        .filter(matterTemp => matterTemp.status !== 'D' && matterTemp.hasOwnProperty('hourlyRates'))
        // Has to have a hourlyRates with type matter
        .filter(matterTemp => !!matterTemp.hourlyRates?.some(item => item.id === user.id))
        // For each matter, go through hourlyRates and replace entries with the matching value
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            if (!!matterTemp.hourlyRates) {
            	_matter.hourlyRates = [...matterTemp.hourlyRates]
                	.map(f => {
	                    if(f.id === user.id) {
	                        const _f = {...f};
	                        _f.id = replaceWith.id;
	                        return _f;
	                    }
	                    else return f;
	                });
            }
            else {
            	_matter.hourlyRates = [];
            }
            _matter.status = 'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    findAll<Conflict>('conflicts')
        // Has to have the userSignOffs property
        .filter(conflictTemp => conflictTemp.status !== 'D' && conflictTemp.hasOwnProperty('userSignOffs'))
        // Has to have a userSignOffs with type conflict
        .filter(conflictTemp => !!conflictTemp.userSignOffs?.some(item => item.userId === user.id))
        // For each conflict, go through userSignOffs and replace entries with the matching value
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            if (!!conflictTemp.userSignOffs) {
            	_conflict.userSignOffs = [...conflictTemp.userSignOffs]
                	.map(f => {
	                    if(f.userId === user.id) {
	                        const _f = {...f};
	                        _f.userId = replaceWith.id;
	                        return _f;
	                    }
	                    else return f;
	                });
            }
            else {
            	_conflict.userSignOffs = [];
            }
            _conflict.status = 'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.addedBy = getCurrentUserId();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });
    return user;
}

/*
 * Determine the impact of deleting this user from other entities
 *
 * @param {User} user
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactUser(user: User) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const matterAssignedToImpact = state.matters
          .getMappingFor('userId', user.id)
          .filter(matter => matter.status !== 'D');

    matterAssignedToImpact.forEach(() => impacts.push('matters'));

    const deadlineCompletedByImpact = state.deadlines
          .getMappingFor('userId', user.id)
          .filter(deadline => deadline.status !== 'D');

    deadlineCompletedByImpact.forEach(() => impacts.push('deadlines'));

    const conflictUserIdsImpact = state.conflicts
          .getMappingFor('userIds', user.id)
          .filter(conflict => conflict.status !== 'D');

    conflictUserIdsImpact.forEach(() => impacts.push('conflicts'));

    const groupUserIdsImpact = state.groups
          .getMappingFor('userId', user.id)
          .filter(group => group.status !== 'D');

    groupUserIdsImpact.forEach(() => impacts.push('groups'));

    const roleUsersImpact = state.roles
          .getMappingFor('userId', user.id)
          .filter(role => role.status !== 'D');

    roleUsersImpact.forEach(() => impacts.push('roles'));

    const templateTaskFavoritedByImpact = state.templateTasks
          .getMappingFor('userId', user.id)
          .filter(templateTask => templateTask.status !== 'D');

    templateTaskFavoritedByImpact.forEach(() => impacts.push('templateTasks'));

    const timeOffApprovedByImpact = state.timeOffs
          .getMappingFor('approvedBy', user.id)
          .filter(timeOff => timeOff.status !== 'D');

    timeOffApprovedByImpact.forEach(() => impacts.push('timeOffs'));

    /* Complex delete usages */
        /* - Impact key/value usages */
    
    const deadlineAssignedToTypeImpact = findAll<Deadline>('deadlines')
        .filter(deadline => deadline.assignedToType === 'U' && deadline.assignedTo === user.id && deadline.status !== 'D');
    deadlineAssignedToTypeImpact.forEach(() => impacts.push('deadlines'));

    const taskAssignedToTypeImpact = findAll<Task>('tasks')
        .filter(task => task.assignedToType === 'U' && task.assignedTo === user.id && task.status !== 'D');
    taskAssignedToTypeImpact.forEach(() => impacts.push('tasks'));

    const templateTaskAssignedToTypeImpact = findAll<TemplateTask>('templateTasks')
        .filter(templateTask => templateTask.assignedToType === 'U' && templateTask.assignedTo === user.id && templateTask.status !== 'D');
    templateTaskAssignedToTypeImpact.forEach(() => impacts.push('templateTasks'));

    /* - Impact embedded value usages */
    
    const matterHourlyRatesImpact = findAll<Matter>('matters')
		.filter(matter => matter.status !== 'D' && matter.hasOwnProperty('hourlyRates'))
		.filter(matter => !!matter.hourlyRates?.some(item => item.id === user.id));
    matterHourlyRatesImpact.forEach(() => impacts.push('matters'));

    const conflictUserSignOffsImpact = findAll<Conflict>('conflicts')
		.filter(conflict => conflict.status !== 'D' && conflict.hasOwnProperty('userSignOffs'))
		.filter(conflict => !!conflict.userSignOffs?.some(item => item.userId === user.id));
    conflictUserSignOffsImpact.forEach(() => impacts.push('conflicts'));

    return util.countDistinct(impacts);
}